import React from 'react';
interface Tab {
  id: string;
  label: string;
  count?: number;
}
interface TabNavProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}
export function TabNav({
  tabs,
  activeTab,
  onTabChange
}: TabNavProps) {
  return <nav className="flex border-b border-gray-200" role="tablist" aria-label="Funded loans views" data-id="element-144">
      {tabs.map(tab => {
      const isActive = activeTab === tab.id;
      return <button key={tab.id} role="tab" aria-selected={isActive} aria-controls={`panel-${tab.id}`} onClick={() => onTabChange(tab.id)} className={`
              relative px-5 py-3 text-sm font-medium transition-colors duration-200
              focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 rounded-t-md
              ${isActive ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700'}
            `} data-id="element-145">
            <span className="flex items-center gap-2" data-id="element-146">
              {tab.label}
              {tab.count !== undefined && <span className={`
                    inline-flex items-center justify-center px-2 py-0.5 text-xs font-semibold rounded-full
                    ${isActive ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'}
                  `} data-id="element-147">
                  {tab.count}
                </span>}
            </span>
            {isActive && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-full" data-id="element-148" />}
          </button>;
    })}
    </nav>;
}